// extracted by mini-css-extract-plugin
export default {"departments-list":"List_departments-list__bd8rq","no-data":"List_no-data__o4mg7"};